import styled from 'styled-components';
import { SummaryOptionsStyled } from '../../SummaryOptionsStyled';
import { rem } from 'polished';

export const SummaryOptionsStyledOV = styled(SummaryOptionsStyled)`
    &.withBorder {
        border-top: ${rem(1)} solid #73767a;
    }

    .titleWrapper {
        .title {
            font-size: ${({ theme }) => theme.fontSizes.h3};
        }

        .isClose {
            svg {
                path {
                    fill: ${({ theme }) => theme.colors.black};
                }
            }
        }

        .isOpen {
            svg {
                path {
                    stroke: ${({ theme }) => theme.colors.black};
                }
            }
        }
    }

    .optionsWrapper {
        .next-btn,
        .back-btn {
            border-radius: 0;

            &:disabled {
                svg {
                    path {
                        fill: ${({ theme }) => theme.colors.grey3};
                        stroke: ${({ theme }) => theme.colors.white};
                    }
                }
            }

            &:not(:disabled) {
                border-color: ${({ theme }) => theme.colors.black};
            }

            &:not(:disabled):hover,
            &:not(:disabled):focus-visible {
                border-color: ${({ theme }) => theme.colors.primary};

                svg {
                    path {
                        fill: ${({ theme }) => theme.colors.primary};
                        stroke: ${({ theme }) => theme.colors.white};
                    }
                }
            }
        }
    }
`;
